export const MODAL_OPEN = "MODAL/MODAL_OPEN";
export const MODAL_CLOSE = "MODAL/MODAL_CLOSE";
export const MODAL_TOGGLE = "MODAL/MODAL_TOGGLE";

export default (state = { isOpen: false }, { type, data }) => {
    switch (type) {
    case MODAL_OPEN:
        return { ...state, ...data, isOpen: true };
    case MODAL_CLOSE: 
        return { ...state, prefill: {}, isOpen: false };
    case MODAL_TOGGLE:
        return { isOpen: data.isNextStateOpen };
    default: return state;
    }
};

export const openModal = prefill => ({ type: MODAL_OPEN, data:{ prefill } });
export const closeModal = () => ({ type: MODAL_CLOSE });
export const toggleModal = isNextStateOpen => ({ type: MODAL_TOGGLE, data: { isNextStateOpen } });
